import { ReactNode } from "react";

interface UserDetailsCardProps {
  children: ReactNode;
}

export function UserDetailsCard({ children }: UserDetailsCardProps) {
  return <div className="rounded-lg bg-white">{children}</div>;
}
